module.exports = __webpack_public_path__ + "./images/97887ef1ea0c138a5fdbde7ab7a003d8.webp";